<template>
  <div class="meter-track" :style="{ height, backgroundColor: trackColor }">
    <div class="meter-fill" :style="{ width: `${clamped}%`, backgroundColor: color }"></div>
  </div>
</template>

<script>
import { COLORS } from "./shared";

// Horizontal bar of the dashboard blocks: ``value`` is the filled percent.
export default {
  name: "MeterBar",
  props: {
    value: { type: Number, default: 0 },
    color: { type: String, default: COLORS.green },
    height: { type: String, default: "0.6rem" },
  },
  data() {
    return { trackColor: COLORS.track };
  },
  computed: {
    clamped() {
      return Math.min(Math.max(this.value || 0, 0), 100);
    },
  },
};
</script>

<style scoped>
.meter-track {
  width: 100%;
  border-radius: 0.35rem;
  overflow: hidden;
}

.meter-fill {
  height: 100%;
  border-radius: 0.35rem;
  transition: width 0.3s ease;
}
</style>
